import React from 'react';
import { Typography, IconButton, DialogTitle, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useModal, TitleProps } from '@lwtears/lwt-common-frontend/lib/Modal';

export const DraggableModalTitle: React.FC<TitleProps> = ({ text = '' }) => {
  const theme = useTheme();
  const [, { closeModal }] = useModal();
  const classes = useStyles(theme)();

  return (
    <DialogTitle className={classes.baseTitleClass} id="draggable-handle">
      <Typography variant="caption" style={{ fontSize: '0.875rem', fontWeight: 400 }}>
        {text}
      </Typography>

      <IconButton
        id="draggable-close-button"
        aria-label="close"
        className={classes.closeButton}
        onClick={closeModal}
      >
        <FontAwesomeIcon icon={faTimes} className={classes.closeIcon} />
      </IconButton>
    </DialogTitle>
  );
};

const useStyles = theme =>
  makeStyles(() => ({
    baseTitleClass: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'space-between',
      backgroundColor: '#fff',
      paddingTop: 10,
      paddingBottom: 10,
      position: 'relative'
    },
    closeButton: () => ({
      margin: -10,
      padding: 10,
      top: 0.5,
      color: theme.palette.black.main,
      textAlign: 'center',
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: 'unset !important'
      }
    }),
    closeIcon: {
      fontSize: 14
    }
  }));
